import React, { createClass, PropTypes } from 'react';
import Icon from '../../../tc-ui/icon';
import { TextField } from 'material-ui';

const SearchBar = createClass({

  propTypes: {
    addOrRemoveTag: PropTypes.func,
    searchContent: PropTypes.func,
  },

  getInitialState() {
    return { input: '' };
  },

  addTags() {
    if (this.state.input) this.props.addOrRemoveTag(this.state.input, 'add');
    this.setState({ input: '' });
    this.searchContent();
  },

  preventTabAndAllowEnter: (event) => {
    if (event.which === 9) {
      event.preventDefault();
    }
    if (event.which === 13) {
      event.preventDefault();
      this.addTags();
    }
  },

  searchContent(input) {
    this.props.searchContent(input.toLowerCase());
    this.setState({ input: input.toLowerCase() });
  },

  render() {
    return (
      <div>
        <TextField
          hintText="Add Tags..."
          id="type-ahead-input"
          className="type-ahead-search-input"
          style={{ width: '100%', marginLeft: '-5px' }}
          onKeyDown={this.preventTabAndAllowEnter}
          onChange={({ target: { value } }) => this.searchContent(value)}
        />
        <Icon className="tc-icon-add type-ahead-input-add" onClick={this.addTags} />
      </div>
    );
  },
});

export default SearchBar;



// WEBPACK FOOTER //
// ./src/app/components/connections/connections-tags-modal/connections-tags-typeahead/typeahead-input.jsx